import React from "react"
import InfograficaPage7 from '../../components/mobile/Capitolo2/InfograficaPage7'

const Page7Mobile = ({ backgroundColor, openPercent, color, innerRef }) => {
  return (
    <div ref={innerRef} style={{ background: backgroundColor, color: color }} className="grid-cols-4 md:grid-cols-8">
      <div className='col-4 md:col-6 md:col-offset-left-1'>
        <div>
          <div className='col-1' style={{ height: 2, backgroundColor: '#FF6B29'}}></div>
          <div className='mt-2 font-20 line-height-26'>
            Sostenibilità ambientale, connettività, elettrificazione e guida
            autonoma sono i fattori chiave che stanno contribuendo a ridefinire
            radicalmente la mobilità, e il settore delle flotte aziendali non sta a
            guardare, ma è parte attiva in questo processo di rinnovamento.
          </div>
          <div className='mt-2 font-20 line-height-26'>
            Il 2018 è stato il quarto anno di consistente crescita del settore
            delle flotte aziendali: le vetture gestite a fine anno sono infatti
            aumentate del 14 per cento rispetto alla fine del 2017; si tratta di
            un ciclo di sviluppo iniziato nel 2015 che ha permesso a questo
            comparto di produrre un incremento dei volumi superiore al 50 per
            cento, passando da meno di 600 mila veicoli gestiti a fine 2015
            agli oltre 900mila del dicembre scorso.
          </div>
          <div className='mt-2 font-20 line-height-26'>
            I cambiamenti nel settore hanno forti ripercussioni sulle car policy
            elaborate dai fleet manager, che dovranno comprendere la portata di
            tali evoluzioni partendo dalla scelta dell’alimentazione.
          </div>
          <div className='mt-2 font-20 line-height-26'>
            Lo sviluppo tecnologico delle batterie consente di accrescere l'autonomia
            dei veicoli elettrici a prezzi sempre più competitivi, con conseguente
            incremento della percentuale di veicoli elettrici assegnati ai dipendenti,
            passata nell’ultimo anno in Italia dal 17 per cento al 27 per cento.
          </div>
          <div className='mt-5 barra-arancio'></div>
          <div className='mt-3'>
            <div className='font-family-acumin font-weight-500 font-20 line-height-26'>
              Ma come crescono le flotte<br />
              aziendali in Europa!
            </div>
            <div className='mt-2 font-18 line-height-22'>
              L’evoluzione verso l’alimentazione elettrica nelle flotte aziendali
              continuerà a passi sostenuti, supportata dal calo dei prezzi, dalle
              nuove tecnologie, dagli incentivi e da maggiori dotazioni di
              infrastrutture per la ricarica.
            </div>
            <div className='mt-5 text-center'>
              <InfograficaPage7 />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Page7Mobile
